import _Array$from from 'babel-runtime/core-js/array/from';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _typeof from 'babel-runtime/helpers/typeof';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _getIterator from 'babel-runtime/core-js/get-iterator';
import sget from '@xunlei/sget';
import load from '@xunlei/thunder-ui-vue/lib/directives/load.js';
import { warn, throttle } from '@xunlei/thunder-ui-vue/lib/utils/util.js';
import createDragSortMixin from '@xunlei/thunder-ui-vue/lib/mixins/drag-mixin/index.js';

var NAMESPACE = 'td';

// not deep
function arrayEqual(arr1, arr2) {
  if (!Array.isArray(arr1) || Array.isArray(arr2)) {
    return false;
  }
  if (arr1.length !== arr2.length) {
    return false;
  }
  arr1 = [].concat(_toConsumableArray(arr1)).sort();
  arr2 = [].concat(_toConsumableArray(arr2)).sort();
  for (var i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  return true;
}

function isRectIntersect(x01, x02, y01, y02, x11, x12, y11, y12) {
  var zx = Math.abs(x01 + x02 - x11 - x12);
  var x = Math.abs(x01 - x02) + Math.abs(x11 - x12);
  var zy = Math.abs(y01 + y02 - y11 - y12);
  var y = Math.abs(y01 - y02) + Math.abs(y11 - y12);
  if (zx <= x && zy <= y) {
    return true;
  }
  return false;
}

var listMultiDragTextGenerator = void 0;
var List = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('transition-group', { staticClass: "td-draglist", staticStyle: { "outline": "none" }, attrs: { "name": _vm.moving ? 'drag-list' : '', "tag": "ul", "tabindex": "0" }, nativeOn: { "click": function click($event) {
          return _vm.handleCleanChosen($event);
        }, "keydown": function keydown($event) {
          if (!$event.type.indexOf('key') && $event.keyCode !== 65) {
            return null;
          }$event.preventDefault();if (!$event.ctrlKey) {
            return null;
          }return _vm.handleChooseAll($event);
        } } }, [_vm._l(_vm.list, function (item, index) {
      return _c('li', { directives: [{ name: "show", rawName: "v-show", value: !_vm.status[item.key].hide || !_vm.moving, expression: "!status[item.key].hide || !moving" }], key: item.key, ref: 'item' + index, refInFor: true, staticClass: "td-draglist-item", class: [{ 'is-chosen': _vm.status[item.key].chosen && !_vm.status[item.key].active, 'is-active': _vm.status[item.key].active, 'is-transition': !_vm.status[item.key].moving, 'is-hidden': _vm.status[item.key].moving && _vm.moving }, _vm.sget(item.template, 'class')], attrs: { "data-index": index, "data-key": item.key }, on: { "click": function click($event) {
            $event.stopPropagation();return _vm.handleItemClick($event, item);
          }, "mousedown": function mousedown($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "right", 39, $event.key, ["Right", "ArrowRight"])) {
              return null;
            }if ('button' in $event && $event.button !== 2) {
              return null;
            }return _vm.handleItemClickRight(item);
          } } }, [_vm._t("default", null, { "item": item, "index": index, "chosen": _vm.status[item.key].chosen, "active": _vm.status[item.key].active })], 2);
    }), _vm._v(" "), _c('li', { directives: [{ name: "load", rawName: "v-load", value: { handler: _vm.handleLoad, distance: _vm.loadDistance + 'px' }, expression: "{ handler: handleLoad, distance: `${loadDistance}px` }" }], key: "load" })], 2);
  }, staticRenderFns: [],
  name: NAMESPACE + '-list',

  mixins: [createDragSortMixin({
    multiDragTextGenerator: function multiDragTextGenerator(maxIndexs) {
      return listMultiDragTextGenerator(maxIndexs);
    },

    vertical: true,
    multiple: true,
    supportScroll: true,
    container: function container() {
      return this.$el;
    },
    getList: function getList() {
      return this.listCopy;
    },
    getMoveIndexs: function getMoveIndexs() {
      return this.chosenIndexs;
    },
    onDragStart: function onDragStart(e, item) {
      if (this.chosenKeysCopy.indexOf(item.key) === -1) {
        this.handleItemClick(e, item);
      }
      this.doChosenKeysSort();
    },
    onDragEnd: function onDragEnd() {
      this.needSort = false;
    },
    onUpdateList: function onUpdateList() {
      this.updateList(this.listCopy, false);
    }
  })],

  directives: {
    load: load
  },

  props: {
    list: Array,
    chosenKeys: {
      required: true,
      type: Array
    },
    multiple: Boolean,
    dragSelectable: Boolean,
    immediate: Boolean,
    drop: Boolean, /* drop chosenKeys when start dragging */
    loadMore: Function,
    loadDistance: {
      type: Number,
      default: 100
    },
    clickToFocus: {
      type: Boolean,
      default: true
    },
    multiDragTextGenerator: {
      type: Function,
      default: function _default(maxIndexs) {
        return maxIndexs.length;
      }
    }
  },

  data: function data() {
    return {
      lastItem: null,
      vertical: true,
      dragging: false,
      startX: 0,
      startY: 0,
      currentX: 0,
      currentY: 0,
      scrollTop: 0,
      scrollLeft: 0,
      itemsPosition: [],
      startDragChosenKeys: [],
      chosenKeysCopy: [],
      extChosenKeys: [],
      chosenKeysSorted: false,
      listCopy: [],
      scrollHeight: 0,
      chosenIndexs: [],
      moveTargetKey: null,
      supportScroll: true,
      tdListScrollTop: 0,
      tdListBoundRect: {},
      draggingDetectCallbackId: 0,
      startTdListScrollTop: 0,
      // 如果不等于零，说明clientY 不在 列表容器的Bounding中，如果大于零，说明鼠标在列表下方，否则在列表上方
      clientYDiffWithBoundingRect: 0,
      tdListMaxScrollTop: 0
    };
  },
  created: function created() {
    if (process.env.NODE_ENV !== 'production') {
      var map = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _getIterator(this.list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var i = _step.value;

          if (i.key === undefined || i.key === null) {
            warn(NAMESPACE + '-list', 'Each item of the "list" needs to have a key attribute!');
          } else {
            if (map[i.key]) {
              warn(NAMESPACE + '-list', 'Duplicate key: ' + i.key + ', which will cause errors!');
            }
            map[i.key] = true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    listMultiDragTextGenerator = this.multiDragTextGenerator;
    this.$watch('dragSelectable', function (v) {
      if (v) {
        if (!_this.multiple) {
          process.env.NODE_ENV !== 'production' && warn(NAMESPACE + '-list', 'the "dragSelectable" prop need to work with "multiple" mode');
        } else {
          _this.$el.addEventListener('mousedown', _this.onDragStart);
        }
      } else {
        _this.doDestoryDrag();
      }
    }, { immediate: true });
    var tdList = this.$el;
    tdList.addEventListener('scroll', this.listenTdListScroll);
    this.tdListMaxScrollTop = tdList.scrollHeight - tdList.offsetHeight;
    this.onDraggingThrottle = throttle(this.onDragging.bind(this), 16);
  },


  watch: {
    list: {
      handler: function handler(v) {
        var _this2 = this;

        this.listCopy = [].concat(_toConsumableArray(v));
        this.lastItem = v.find(function (item) {
          return item.key === _this2.chosenKeys[0];
        }) || v[0];
        this.chosenKeysCopy = this.chosenKeys.filter(function (key) {
          return v.findIndex(function (item) {
            return item.key === key;
          }) !== -1;
        });
        this.extChosenKeys = this.chosenKeys.filter(function (key) {
          return v.findIndex(function (item) {
            return item.key === key;
          }) === -1;
        });
        if (this.needSort) {
          this.doChosenKeysSort();
          this.needSort = false;
        }
      },

      immediate: true
    },
    chosenKeys: {
      handler: function handler(v) {
        var _this3 = this;

        this.chosenKeysCopy = v.filter(function (key) {
          return _this3.listCopy.findIndex(function (item) {
            return item.key === key;
          }) !== -1;
        });
        this.extChosenKeys = v.filter(function (key) {
          return _this3.listCopy.findIndex(function (item) {
            return item.key === key;
          }) === -1;
        });
        if (v.length) {
          this.lastItem = this.listCopy.find(function (item) {
            return item.key === v[0];
          }) || this.listCopy[0];
        } else {
          this.lastItem = this.listCopy[0];
        }
      },

      immediate: true,
      sync: true
    },
    chosenKeysCopy: {
      handler: 'updateChosenIndexs',
      immediate: true,
      sync: true
    },
    listCopy: {
      handler: 'updateChosenIndexs',
      immediate: true,
      sync: true
    },
    'list.length': {
      handler: function handler() {
        var _this4 = this;

        if (this.moving && this.moveKeys) {
          var _loop = function _loop(k) {
            if (_this4.list.findIndex(function (item) {
              return item.key === k;
            }) === -1) {
              return {
                v: _this4.onSortEnd()
              };
            }
          };

          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = _getIterator(this.moveKeys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var k = _step2.value;

              var _ret = _loop(k);

              if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
        this.rectUpdated = false;
        this.$nextTick(function () {
          _this4.scrollHeight = _this4.$el.scrollHeight;
          _this4.updateRect();
          _this4.rectUpdated = true;
          _this4.isScrollable && _this4.doScroll(_this4.lastMouseEvent);
        });
      },

      sync: true
    },
    dragging: function dragging(val) {
      if (val) {
        this.draggingDetectCallbackId = window.requestAnimationFrame(this.draggingDetect.bind(this));
      } else {
        window.cancelAnimationFrame(this.draggingDetectCallbackId);
      }
    }
  },

  computed: {
    status: function status() {
      var _this5 = this;

      var status = {};

      this.listCopy.forEach(function (item, index) {
        status[item.key] = {};
        if (_this5.chosenIndexs.indexOf(index) > -1) {
          status[item.key].moving = true;
          if (_this5.moveTargetKey !== item.key) {
            status[item.key].hide = true;
          }
        }
        status[item.key].chosen = _this5.isChosen(item);
        status[item.key].active = _this5.isActive(item);
      });

      return status;
    },
    realtimeStartY: function realtimeStartY() {
      return this.startTdListScrollTop - this.tdListScrollTop + this.startY;
    },
    realtimeCurrentY: function realtimeCurrentY() {
      return this.currentY + this.tdListScrollTop;
    }
  },

  methods: {
    updateChosenIndexs: function updateChosenIndexs() {
      var _this6 = this;

      this.chosenIndexs = this.chosenKeysCopy.map(function (k) {
        return _this6.listCopy.findIndex(function (item) {
          return item.key === k;
        });
      });
    },
    doChosenKeysSort: function doChosenKeysSort(e) {
      var moveItem = this.moveItem,
          chosenKeysCopy = this.chosenKeysCopy,
          chosenIndexs = this.chosenIndexs,
          listCopy = this.listCopy;

      if (chosenKeysCopy.length <= 1) {
        return;
      }
      var swaped = false;
      for (var i = 1; i < chosenIndexs.length; i++) {
        if (chosenIndexs[i] - chosenIndexs[i - 1] > 1) {
          swaped = true;
          break;
        }
      }
      if (swaped) {
        var newList = [];
        var moveItemIndex = listCopy.findIndex(function (item) {
          return item.key === moveItem.key;
        });
        for (var _i = 0; _i < moveItemIndex; _i++) {
          if (chosenIndexs.indexOf(_i) === -1) {
            newList.push(listCopy[_i]);
          }
        }
        for (var _i2 = 0; _i2 < chosenIndexs.length; _i2++) {
          newList.push(listCopy[chosenIndexs[_i2]]);
        }
        for (var _i3 = moveItemIndex + 1; _i3 < listCopy.length; _i3++) {
          if (chosenIndexs.indexOf(_i3) === -1) {
            newList.push(listCopy[_i3]);
          }
        }
        this.updateList(newList, true);
      }
    },
    updateList: function updateList(list, fromKeysSort) {
      var _list = [].concat(_toConsumableArray(list));
      var map = {};
      var i = 0;
      var duplicate = void 0;
      while (i < _list.length) {
        if (map[_list[i].key]) {
          warn('List', 'duplicate key from ' + (fromKeysSort ? 'doChosenKeysSort' : 'handleSort') + '\n duplicate key: ' + _list[i].key + ', duplicate index: ' + i);
          duplicate = true;
          _list.splice(i, 1);
        } else {
          map[_list[i].key] = true;
          i++;
        }
      }
      if (duplicate) {
        console.warn('oldList:', this.list.map(function (item) {
          return item.key;
        }), 'newList:', list.map(function (item) {
          return item.key;
        }), 'updateList:', JSON.parse(_JSON$stringify(_list)), 'updateList.key:', _list.map(function (item) {
          return item.key;
        }));
      }
      this.$emit('update:list', _list);
    },


    sget: sget,
    clamp: function clamp(min, max, val) {
      return val < min ? min : val > max ? max : val;
    },
    onDragStart: function onDragStart(e) {
      if (this.clickToFocus) {
        this.$el.focus();
      }

      if (e.which === 1) {
        this.setTdListBoundingRect();
        var _tdListBoundRect = this.tdListBoundRect,
            left = _tdListBoundRect.left,
            top = _tdListBoundRect.top;

        e.preventDefault();
        this.dragging = true;
        this.isClick = true;
        this.startX = this.currentX = e.clientX - left;
        this.startY = this.currentY = e.clientY - top;
        this.scrollTop = document.documentElement.scrollTop;
        this.scrollLeft = document.documentElement.scrollLeft;
        this.startTdListScrollTop = this.tdListScrollTop;
        this.startDragChosenKeys = this.drop ? [] : [].concat(_toConsumableArray(this.chosenKeysCopy));
        window.addEventListener('mousemove', this.onDraggingThrottle);
        window.addEventListener('mouseup', this.onDragEnd);
        if (!this.dragArea) {
          var dragArea = this.dragArea = document.createElement('div');
          dragArea.className = 'td-drag-area';
          this.$el.parentNode.appendChild(dragArea);
        }
        this.updatePosition();
      }
    },
    onDragging: function onDragging(e) {
      var _tdListBoundRect2 = this.tdListBoundRect,
          left = _tdListBoundRect2.left,
          right = _tdListBoundRect2.right,
          bottom = _tdListBoundRect2.bottom,
          top = _tdListBoundRect2.top;

      if (this.dragging) {
        if (this.drop && this.chosenKeysCopy && this.chosenKeysCopy.length) {
          this.updateChosenKeys([]);
        }
        this.isClick = false;
        e.preventDefault();
        this.currentX = this.clamp(left, right, e.clientX);
        this.currentY = this.clamp(top, bottom, e.clientY);

        this.clientYDiffWithBoundingRect = e.clientY - this.currentY;

        this.dragArea.style.cssText = '\n          width: ' + Math.abs(this.currentX - this.startX - left) + 'px;\n          height: ' + Math.abs(this.currentY - this.realtimeStartY - top) + 'px;\n          top: ' + (Math.min(this.currentY - top, this.realtimeStartY) + this.scrollTop) + 'px;\n          left: ' + (Math.min(this.currentX - left, this.startX) + this.scrollLeft) + 'px\n        ';
        if (this.immediate) {
          this.setDragChosen();
        }
      }
    },
    onDragEnd: function onDragEnd(e) {
      var _this7 = this;

      if (this.dragging) {
        window.cancelAnimationFrame(this.draggingDetectCallbackId);
        // 防止在 mouseup 后立即触发 click，导致触发clean
        // 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
        setTimeout(function () {
          _this7.dragging = false;
          if (!_this7.isClick) {
            _this7.setDragChosen();
            _this7.dragArea.style.cssText = 'display: none';
          }
        }, 0);
      }
      // 防止下次只是长按时列表自动移动。
      this.clientYDiffWithBoundingRect = 0;
      window.removeEventListener('mousemove', this.onDraggingThrottle);
      window.removeEventListener('mouseup', this.onDragEnd);
    },
    draggingDetect: function draggingDetect() {
      if (this.clientYDiffWithBoundingRect !== 0) {
        var nextTdListScrollTop = this.clamp(0, this.tdListMaxScrollTop, this.tdListScrollTop + this.clientYDiffWithBoundingRect);
        this.$el.scrollTop = nextTdListScrollTop;
        this.setDragChosen();
      }
      this.draggingDetectCallbackId = window.requestAnimationFrame(this.draggingDetect.bind(this));
    },
    setDragChosen: function setDragChosen() {
      var dragArea = this.dragArea,
          listCopy = this.listCopy,
          startDragChosenKeys = this.startDragChosenKeys,
          itemsPosition = this.itemsPosition;

      var chosenKeys = [].concat(_toConsumableArray(startDragChosenKeys));
      var dragChosenKeys = [];
      var dragAreaRect = dragArea.getBoundingClientRect();
      var _ref = [dragAreaRect.left, dragAreaRect.left + dragAreaRect.width, dragAreaRect.top, dragAreaRect.top + dragAreaRect.height],
          dX1 = _ref[0],
          dX2 = _ref[1],
          dY1 = _ref[2],
          dY2 = _ref[3];

      itemsPosition.forEach(function (rect, index) {
        var iX1 = rect.x1,
            iX2 = rect.x2,
            iY1 = rect.y1,
            iY2 = rect.y2;

        if (isRectIntersect(iX1, iX2, iY1, iY2, dX1, dX2, dY1, dY2)) {
          dragChosenKeys.push(listCopy[index].key);
        }
      });
      dragChosenKeys.forEach(function (k) {
        if (!chosenKeys.includes(k)) {
          chosenKeys.push(k);
        }
      });
      if (!arrayEqual(chosenKeys, this.chosenKeysCopy)) {
        this.updateChosenKeys(chosenKeys);
      }
    },
    isChosen: function isChosen(item) {
      if (this.multiple) {
        return this.chosenKeysCopy.includes(item.key);
      } else {
        return this.chosenKeysCopy === item.key;
      }
    },
    isActive: function isActive(item) {
      if (this.multiple) {
        // return this.chosenKeysCopy.includes(item.key) && !(this.sortByHandler && this.dragging) && this.chosenKeysCopy.length === 1
        return this.chosenKeysCopy.includes(item.key) && this.chosenKeysCopy.length === 1;
      } else {
        return this.chosenKeysCopy === item.key;
      }
    },
    handleChooseAll: function handleChooseAll() {
      this.updateChosenKeys(this.listCopy.map(function (item) {
        return item.key;
      }), true);
    },
    handleCleanChosen: function handleCleanChosen() {
      this.updateChosenKeys([]);
    },
    handleItemClick: function handleItemClick(e, item) {
      var _this8 = this;

      if (this.clickToFocus) {
        this.$el.focus();
      }

      if (!this.multiple) {
        this.updateChosenKeys([item.key]);
        return;
      }

      var chosenKeys = [];

      if (e.ctrlKey) {
        this.lastItem = item;
        chosenKeys = [].concat(_toConsumableArray(this.chosenKeysCopy));

        if (chosenKeys.includes(item.key)) {
          chosenKeys.splice(chosenKeys.indexOf(item.key), 1);
        } else {
          chosenKeys.push(item.key);
        }
      } else if (e.shiftKey) {
        var lastIndex = this.listCopy.findIndex(function (item) {
          return item.key === _this8.lastItem.key;
        });
        var index = this.listCopy.indexOf(item);

        if (index >= lastIndex) {
          for (var i = lastIndex; i <= index; i++) {
            chosenKeys.push(this.listCopy[i].key);
          }
        } else {
          for (var _i4 = index; _i4 <= lastIndex; _i4++) {
            chosenKeys.push(this.listCopy[_i4].key);
          }
        }
      } else {
        this.lastItem = item;
        chosenKeys = [item.key];
      }

      this.chosenKeysCopy = chosenKeys;

      this.updateChosenKeys(chosenKeys, false, !!e.ctrlKey);
    },
    handleItemClickRight: function handleItemClickRight(item) {
      this.lastItem = item;

      if (!this.chosenKeys.includes(item.key)) {
        this.updateChosenKeys([item.key]);
      }
    },
    handleLoad: function handleLoad() {
      var _this9 = this;

      var loadMore = this.loadMore;

      typeof loadMore === 'function' && loadMore(function () {
        if (_this9.moving) {
          _this9.needSort = true;
        }
      });
    },
    doDestoryDrag: function doDestoryDrag() {
      window.removeEventListener('mousedown', this.onDragStart);
      if (this.dragArea) {
        document.body.removeChild(this.dragArea);
        this.dragArea = null;
      }
    },
    updatePosition: function updatePosition() {
      var _this10 = this;

      var lis = _Array$from(this.$el.children);
      this.itemsPosition = [];
      lis.forEach(function (li) {
        if (li.classList.contains('td-draglist-item')) {
          var rect = li.getBoundingClientRect();
          _this10.itemsPosition.push({
            x1: rect.left,
            y1: rect.top,
            x2: rect.left + rect.width,
            y2: rect.top + rect.height
          });
        }
      });
    },
    updateChosenKeys: function updateChosenKeys(keys, sorted, needExt) {
      var _this11 = this;

      if (!sorted && keys.length >= 2) {
        var keyToIndex = keys.map(function (k) {
          return _this11.listCopy.findIndex(function (item) {
            return item.key === k;
          });
        });
        keyToIndex.sort(function (a, b) {
          return a - b;
        });
        keys = keyToIndex.map(function (index) {
          return _this11.listCopy[index].key;
        });
      }
      if (needExt) {
        keys = keys.concat(this.extChosenKeys);
      }
      this.$emit('update:chosenKeys', keys);
    },
    listenTdListScroll: function listenTdListScroll() {
      this.tdListScrollTop = this.$el.scrollTop;
      this.updatePosition();
    },
    setTdListBoundingRect: function setTdListBoundingRect() {
      this.tdListBoundRect = this.$el.getBoundingClientRect();
    }
  },

  beforeDestory: function beforeDestory() {
    this.dragSelectable && this.multiple && this.doDestoryDrag();
    this.$el.removeEventListener('scroll', this.listenTdListScroll);
  }
};

List.install = function (Vue) {
  Vue.component(List.name, List);
};

export default List;
